// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__YkG7s","Open":"SideDrawer__Open__38Lio","Close":"SideDrawer__Close__39sCp","Logo":"SideDrawer__Logo__3Io8N"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/SideDrawer/SideDrawer.css
// module id = 95
// module chunks = 0